import { FunctionalComponent, h } from "@stencil/core";

interface ToggleButtonProps {
    baseClass: string;
    label: string;
    accordion: boolean;
    onClick: () => void;
}

const ToggleButton: FunctionalComponent<ToggleButtonProps> = ({ baseClass, label, onClick, accordion }) => (
    <button type="button" class={`ux-collapsible-button`} onClick={onClick}>
        {accordion && (
            <span class={`ux-collapsible-button__icon`}>
                <ux-icon name="chevron-down" weight="bold" class={`ux-collapsible-arrow`} />
            </span>
        )}
        {accordion && <span class={`${baseClass}-button__spacer`} aria-hidden />}
        <span class={`${baseClass}-button__label`}>{label}</span>
        <span class={`${baseClass}-button__spacer`} aria-hidden />
        <span class={`ux-collapsible-button__icon`}>
            <ux-icon name="chevron-down" weight="bold" class={`ux-collapsible-arrow`} />
        </span>
    </button>
);

export default ToggleButton;
